/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck

import React from 'react';

export interface ISubHeadingProps {
  subHeadingText?: string;
}

export const SubHeading = (props: ISubHeadingProps) => {
  const { subHeadingText } = props;
  if (subHeadingText) {
    return <p style={{ textAlign: 'center' }}>{subHeadingText}</p>;
  }
  return null;
};

SubHeading.defaultProps = {
  // subHeadingText:
  //   "Enter your email address and we will send you instructions to reset your password.",
};
